import * as angular from "angular"; 

import { directivesModule } from "../directivesModule";

export interface ILayout {
	Method: string;
	Pane: string; 
}

export class ATXRedrawService  {
	constructor() {

	}

	private onLayoutFunctions: ((p: ILayout) => void)[] = [];
	public Layout(method:string, pane:string) {
		for (let callback of this.onLayoutFunctions) {
			callback({ Method: method, Pane: pane });
		}
	}
	public OnLayout(callback: (p: ILayout) => void) {
		this.onLayoutFunctions.push(callback);
	}
	public RemoveOnLayout(callback: (p: ILayout) => void) {
		let idx = this.onLayoutFunctions.indexOf(callback);
		if (idx >= 0) {
			this.onLayoutFunctions.splice(idx, 1); 
		}
	}

	private onAppTrayPinChangeFunctions: (() => void)[] = [];
	public AppTrayPinChange() {
		for (let callback of this.onAppTrayPinChangeFunctions) {
			callback();
		}
	}
	public OnAppTrayPinChange(callback: () => void) {
		this.onAppTrayPinChangeFunctions.push(callback);
	}
	public RemoveOnAppTrayPinChange(callback: () => void) {
		let idx = this.onAppTrayPinChangeFunctions.indexOf(callback);
		if (idx >= 0) {
			this.onAppTrayPinChangeFunctions.splice(idx, 1);
		}
	}
}

directivesModule.service("ATXRedrawService", [() => new ATXRedrawService()]);


// WEBPACK FOOTER //
// ./Common/Layout/ATXRedrawService.ts